import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useCookies from '../hooks/useCookies';

const ProtectedRoute = () => {
  const { getCookie } = useCookies();
  const isAuthenticated = localStorage.getItem('isAuthenticated');
  const authToken = localStorage.getItem('authToken');
  const tokenFromCookie = getCookie('token');

  const isAuth = isAuthenticated && authToken || tokenFromCookie;
  return isAuth ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoute;
